/**
 * Marketing section wrapper.
 *
 * Routing:
 *   /marketing                             → Reports listing (if no query params)
 *   /marketing?breakdown=...&metrics=...   → Standalone marketing builder (deep link)
 *   /marketing/new                         → New marketing report builder
 *   /marketing/reports/:id                 → Saved report builder (loaded from config)
 */
import { SectionPage } from '@/components/layout/SectionPage';
import { MarketingBuilder } from './MarketingBuilder';

export function MarketingPage() {
  return (
    <SectionPage
      basePath="/marketing"
      BuilderComponent={MarketingBuilder}
      queryParamKeys={['breakdown', 'metrics', 'preset']}
    />
  );
}
